import React, { useEffect, useState } from 'react';
import { Form, Button, Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Select, { StylesConfig } from "react-select";
import { useGetAssignmentDetailByIdQuery, useGetCreateUserLookupQuery, useGetRegionAndSiteQuery, useGetSystemSuggestionDetailsQuery, useLazyGetAssignmentDetailByIdQuery, useLazyGetEnterpriseMemberByNameQuery, useLazyGetEnterpriseMemberByRoleQuery, useLazyGetRegionAndSiteQuery, useLazyGetSiteAndRegionbyZipQuery, useLazyGetTeamMemberByNameQuery, useLazyGetTeamMemberByRoleQuery, useLazyTeamDetailsInProjectQuery, useUpsertProjectAssignmentDetailsMutation } from '../../../../../services/EndPointsApis';
import { useFormik } from 'formik';
import TextField from '../../../../../core/common/textFields/TextField';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import * as Yup from "yup";

// import Select from "react-dropdown-select";
const steps = ['1', '2', '3', '4'];

interface StepperAssignmentProps {
    togglestepperAssignment?: boolean;
    closestepper?: () => void;
    isEditing?: boolean;
    projectId?: any
    BusinessUnitValue?: any
    projectLookups?: any
    refetchAssignments?: any
    projectRecordNumber?: any
    refetch?: any
    refetchClientView?: any
    setBusinessUnitValue?: any
}

const customStyles: StylesConfig = {
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isFocused ? "rgba(177, 31, 40, 1)" : "#fff",
        color: state.isFocused ? "#fff" : "#000",
        "&:hover": {
            backgroundColor: "rgba(177, 31, 40, 1)",
        },
    }),
    menuPortal: base => ({ ...base, zIndex: 9999 })
};



const AssignmentSidebar = ({ setBusinessUnitValue, projectLookups, projectRecordNumber, refetch, refetchClientView, refetchAssignments, togglestepperAssignment, projectId, BusinessUnitValue, closestepper, isEditing }: any) => {
    const [activeStep, setActiveStep] = useState(0);
    const [selectedTeam, setSelectedTeam] = useState(null)
    const [selectedTeamBu, setSelectedTeamBu] = useState(null)
    const [projectRegionId, setProjectRegionId] = useState('')
    const [projectNumDynamic, setProjectNumDynamic] = useState('')
    const [selectedFormatBusiness, setSelectedFormatBusiness] = useState('Name(Role)');
    const [selectedFormat, setSelectedFormat] = useState('Name(Role)');

    const [dropdownOpen, setDropdownOpen] = useState(true);

    //Teams Lookup
    const { data: usersLookup } = useGetCreateUserLookupQuery('');//lookups users
    //Get teams Details By Id
    const [triggerTeamDetails, { data: teamsDetails }] = useLazyTeamDetailsInProjectQuery();
    //teams BY Name
    const [triggerTeamsByName, { data: teamsByName }] = useLazyGetTeamMemberByNameQuery();
    //teams BY Role
    const [triggerTeamsByRole, { data: teamsByRole }] = useLazyGetTeamMemberByRoleQuery();
    //Get System Team Details
    const { data: systemSuggestion, refetch: refetchSystemSuggestions } = useGetSystemSuggestionDetailsQuery('');
    //Create Update Assignment
    const [createAssignment, { data: AssignmentData, isError, error, isSuccess, isLoading }] = useUpsertProjectAssignmentDetailsMutation();
    //teams BY Business Name
    const [triggerTeamsByBusinessName, { data: teamsByBusinessName }] = useLazyGetEnterpriseMemberByNameQuery();
    //teams BY Business Role
    const [triggerTeamsByBusinessRole, { data: teamsByBusinessRole }] = useLazyGetEnterpriseMemberByRoleQuery();
    //Get Assignment Detail BY Id
    const [triggerAssignmentById, { data: assignmentByIdData }] = useLazyGetAssignmentDetailByIdQuery();
    //Get  Teams BY regionId and site
    const [triggerRegionSite, { data: teamsData }] = useLazyGetRegionAndSiteQuery();
    //get region and siteid
    const [triggerRegionSiteByZip, { data: regionSiteData, isSuccess: isSuccessRegionSite, isFetching }] = useLazyGetSiteAndRegionbyZipQuery();

    const getdefaultLookups = useSelector((state: any) => state.auth.apiData);

    const handleNext = () => {
        if (activeStep < steps.length - 1) {
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
        } else {
            formik.handleSubmit()
            closestepper();
        }
    };
    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };
    const validationSchemaAssignment = Yup.object().shape({
        lst_Site: Yup.object({
            id: Yup.number().min(1, 'Site must be selected').required('Site is required'),
        }).required(),
        lst_Region: Yup.object({
            id: Yup.number().min(1, 'Region must be selected').required('Region is required'),
        }).required(),
        lst_UserTeam: Yup.object({
            id: Yup.number().min(1, 'Team must be selected').required('Team is required'),
        }).required(),
        // lst_EnterPriseBusinessUnit: Yup.object({
        //     id: Yup.number().min(1, 'Business Unit must be selected').required('Business Unit is required'),
        // }).required(),
    });

    const initialValues = {
        id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        projectId: projectId,
        projectRecNumber: projectRecordNumber,
        systemRegion: "",
        lst_Site: {
            id: 0,
            value: ""
        },
        systemTeam: "",
        lst_Region: {
            id: 0,
            value: ""
        }, userSite: "",
        lst_BusinessUnit: {
            id: BusinessUnitValue?.value,
            value: BusinessUnitValue?.label
        },
        lst_UserTeam: {
            id: 0,
            value: ""
        },
        lst_EnterPriseBusinessUnit: {
            id: 0,
            value: ""
        },
        assignTeamsMembersByName: [
            {
                id: 0,
                value: "",
                roleId: 0
            }
        ],
        assignTeamsMembersByRole: [
            {
                id: 0,
                value: "",
                roleId: 0
            }
        ],
        assignEntTeamsMembersByName: [
            {
                id: 0,
                value: "",
                roleId: 0
            }
        ],
        assignEntTeamsMembersByRole: [
            {
                id: 0,
                value: "",
                roleId: 0
            }
        ]
    }
    const formik = useFormik({
        initialValues,
        validationSchema: validationSchemaAssignment,
        onSubmit: (values) => {
            createAssignment({ ...values, projectRecNumber: projectRecordNumber })
        }
    })
    const { resetForm } = formik;
    const [updatedId, setUpdateId] = useState(null)

    useEffect(() => {
        if (assignmentByIdData?.result && Object.keys(assignmentByIdData?.result).length > 0 && togglestepperAssignment === true) {
            setUpdateId(assignmentByIdData?.result?.userAccountId);
            setProjectNumDynamic(assignmentByIdData?.result?.projectRecNumber)
            formik.setFieldValue('projectRecNumber', assignmentByIdData?.result?.projectRecNumber);
        } else {
            setUpdateId(null);
            // resetForm();
        }
    }, [assignmentByIdData, togglestepperAssignment]);

    useEffect(() => {
        formik.setFieldValue("systemRegion", systemSuggestion?.result?.systemRegion);
        formik.setFieldValue("systemTeam", systemSuggestion?.result?.systemTeam);
        formik.setFieldValue("systemSite", systemSuggestion?.result?.systemSite);
    }, [systemSuggestion?.result, updatedId]);

    useEffect(() => {
        if (teamsData) {
            formik.setFieldValue("userRegion", teamsDetails?.result?.userRegion);
            formik.setFieldValue("userSite", teamsDetails?.result?.userSite);
            if ((formik?.values?.lst_Site.id !== 0 && formik?.values?.lst_Site.id !== undefined) && (formik?.values?.lst_Region.id !== 0 && formik?.values?.lst_Region.id !== undefined)) {
                setProjectNumDynamic(`${formik?.values?.lst_Site.id < 10 ? `0${formik?.values?.lst_Site?.id}` : formik?.values?.lst_Site?.id}-${formik?.values?.lst_Region?.id < 10 ? `0${formik?.values?.lst_Region?.id}` : formik?.values?.lst_Region}-${formik.values.projectRecNumber}`)
            }
        }
    }, [teamsData]);

    useEffect(() => {
        if (togglestepperAssignment === true) {
            refetchSystemSuggestions()
            triggerAssignmentById({ projectId: projectId })
            triggerRegionSiteByZip({ projectId: projectId })
            triggerRegionSite({ siteId: regionSiteData?.result?.site?.id, regionId: regionSiteData?.result?.region?.id })
        }

    }, [togglestepperAssignment])

    // useEffect(() => {

    //     if (togglestepperAssignment === true && assignmentByIdData?.result?.lst_EnterPriseBusinessUnit.id !== null) {
    //         triggerTeamsByBusinessName({ businessUnitId: assignmentByIdData?.result?.lst_EnterPriseBusinessUnit.id })
    //         triggerTeamsByBusinessRole({ businessUnitId: assignmentByIdData?.result?.lst_EnterPriseBusinessUnit.id })
    //     }
    //     if (togglestepperAssignment === true && assignmentByIdData?.result?.lst_UserTeam.id !== null) {
    //         triggerTeamsByName({ teamID: assignmentByIdData?.result?.lst_UserTeam.id })
    //         triggerTeamsByRole({ teamID: assignmentByIdData?.result?.lst_UserTeam.id })
    //     }
    // }, [assignmentByIdData])

    useEffect(() => {
        if (isSuccess) {
            toast.success(AssignmentData?.message);
            closestepper();
            resetForm()
            setActiveStep(0)
            refetchAssignments()
            refetch()
            refetchClientView()
            setTimeout(() => {
                setBusinessUnitValue({ label: '', value: 0 })
            }, 500);
        }
        // if (isEdit && isSuccess) {
        //   toast.success('User Updated Successfully');
        //   handleClose();
        //   refetch()
        // }
    }, [isSuccess]);

    useEffect(() => {
        if (isError && error) {
            let errorMessage: string = 'Something went wrong';
            console.log(error, 'errorMessage');

            if ('data' in error && error.data && typeof error.data === 'object' && 'message' in error.data) {

                errorMessage = (error.data as { message: string }).message;
            }

            toast.error(errorMessage);
            // resetForm()
        }
    },
        [isError, error]);
    const handleRadioChange = (event: any) => {
        setSelectedFormat(event.target.value);
    };
    const handleRadioChangeBusiness = (event: any) => {
        setSelectedFormatBusiness(event.target.value);
    };

    const optionsTeam = selectedFormat === 'Name(Role)'
        ? teamsByName?.result?.map((option: any) => ({
            label: option?.value,
            value: option?.id,
            roleId: option?.roleId
        })) || []
        : teamsByRole?.result?.map((option: any) => ({
            label: option?.value,
            value: option?.id,
            roleId: option?.roleId
        })) || [];

    const selectedIds = formik?.values?.assignTeamsMembersByName?.map((item: any) => item?.id) || [];

    const optionsBusinesTeam = selectedFormatBusiness === 'Name(Role)'
        ? teamsByBusinessName?.result
            ?.filter((option: any) => !selectedIds.includes(option?.id))
            ?.map((option: any) => ({
                label: option?.value,
                value: option?.id,
                roleId: option?.roleId

            })) || []
        : teamsByBusinessRole?.result
            ?.filter((option: any) => !selectedIds.includes(option?.id))
            ?.map((option: any) => ({
                label: option?.value,
                value: option?.id,
                roleId: option?.roleId

            })) || [];

    type TeamOption = {
        id: number;
        value: string;
        roleId: number
    };
    const handleChangeTeam = (newValue: any) => {
        const updatedValues: TeamOption[] = newValue.map((option: { value: any; label: any; roleId: any }) => ({
            id: option.value,
            value: option.label,
            roleId: option.roleId
        }));
        if (selectedFormat === 'Name(Role)') {
            formik.setFieldValue('assignTeamsMembersByName', updatedValues);
        } else if (selectedFormat === 'Role(Name)') {
            formik.setFieldValue('assignTeamsMembersByRole', updatedValues);
        }
    };

    const handleChangeTeamBusiness = (newValue: any) => {
        const updatedValues: TeamOption[] = newValue.map((option: { value: any; label: any, roleId: any }) => ({
            id: option.value,
            value: option.label,
            roleId: option.roleId
        }));
        if (selectedFormatBusiness === 'Name(Role)') {
            formik.setFieldValue('assignEntTeamsMembersByName', updatedValues);

        } else if (selectedFormatBusiness === 'Role(Name)') {
            formik.setFieldValue('assignEntTeamsMembersByRole', updatedValues);
        }

    };

    const selectValuesTeam = selectedFormat === 'Name(Role)'
        ? (formik.values.assignTeamsMembersByName || [])
            .filter((team: { id: number; value: string; roleId: number }) => team.id !== 0 && team.value !== '')
            .map((team: { id: number; value: string; roleId: number }) => ({
                value: team.id,
                label: team.value,
                roleId: team.roleId
            }))
        : (formik.values.assignTeamsMembersByRole || [])
            .filter((team: { id: number; value: string; roleId: number }) => team.id !== 0 && team.value !== '')
            .map((team: { id: number; value: string; roleId: number }) => ({
                value: team.id,
                label: team.value,
                roleId: team.roleId

            }));
    const selectValuesTeamBusiness = selectedFormatBusiness === 'Name(Role)'
        ? (formik.values.assignEntTeamsMembersByName || [])
            .filter((team: { id: number; value: string; roleId: number }) => team.id !== 0 && team.value !== '')
            .map((team: { id: number; value: string; roleId: number }) => ({
                value: team.id,
                label: team.value,
                roleId: team.roleId

            }))
        : (formik.values.assignEntTeamsMembersByRole || [])
            .filter((team: { id: number; value: string; roleId: number }) => team.id !== 0 && team.value !== '')
            .map((team: { id: number; value: string; roleId: number }) => ({
                value: team.id,
                label: team.value,
                roleId: team.roleId

            }));

    useEffect(() => {
        formik.setFieldValue('lst_BusinessUnit.id', BusinessUnitValue?.value)
        formik.setFieldValue('lst_BusinessUnit.value', BusinessUnitValue?.label)
    }, [togglestepperAssignment])

    useEffect(() => {
        if (togglestepperAssignment === false) {
            setActiveStep(0)
            setTimeout(() => {
                resetForm()
            }, 1000);
        }
    }, [togglestepperAssignment])

    const handleSubmit = () => {
        formik.handleSubmit()
    }
    useEffect(() => {
        if (teamsData) {
            formik.setFieldValue("lst_UserTeam.id", 0)
            formik.setFieldValue("lst_UserTeam.value", '')
        }
    }, [teamsData])

    useEffect(() => {
        if (regionSiteData?.result?.region !== null && regionSiteData?.result?.site !== null) {
            formik.setFieldValue("lst_Site.id", regionSiteData?.result?.site?.id)
            formik.setFieldValue("lst_Site.value", regionSiteData?.result?.site?.value)
            formik.setFieldValue("lst_Region.id", regionSiteData?.result?.region?.id)
            formik.setFieldValue("lst_Region.value", regionSiteData?.result?.region?.value)
            triggerRegionSite({ siteId: regionSiteData?.result?.site?.id, regionId: regionSiteData?.result?.region?.id })
        }
    }, [isFetching])




    return (
        <div className={togglestepperAssignment ? "toggle-popup sidebar-popup" : "toggle-popup"}>
            <div className="sidebar-layout">
                <div className='sidebar-header justify-content-end p-1'>
                    <Link to="#" className="sidebar-close toggle-btn" onClick={closestepper}>
                        <i className="ti ti-x" />
                    </Link>
                </div>
                <div className=" sidebar-header p-1">
                    <h4>{isEditing ? `Edit ${BusinessUnitValue?.label}` : `${BusinessUnitValue?.label}`} </h4>

                    <div className="submit-button text-end">
                        <button
                            className="btn btn-light"
                            onClick={closestepper}
                        >
                            Cancel
                        </button>
                        <button
                            className='btn btn-primary'
                            type='submit'
                            onClick={handleSubmit}
                        >
                            Save
                        </button>
                    </div>
                </div>
                {/* <form onSubmit={formik.handleSubmit}> */}
                <div className="toggle-body">
                    <div className="toggle-height">
                        <div className="pro-create">
                            <form onSubmit={formik.handleSubmit}>
                                <div className='row'>
                                    <div className="col-md-6">
                                        <div className="form-wrap">
                                            <label className="input-label">
                                                Site <span className="text-danger">*</span>
                                            </label>
                                            <Select
                                                styles={customStyles}
                                                className="select"
                                                options={getdefaultLookups?.result?.Lst_Site?.map((option: any) => ({
                                                    label: option?.value,
                                                    value: option?.id
                                                }))}
                                                value={
                                                    formik.values?.lst_Site?.id
                                                        ? {
                                                            value: formik.values?.lst_Site?.id,
                                                            label: formik.values?.lst_Site?.value || '',
                                                        }
                                                        : []
                                                }
                                                onChange={(selectedOption: any) => {
                                                    formik.setFieldValue('lst_Site.id', selectedOption.value);
                                                    formik.setFieldValue('lst_Site.value', selectedOption.label);
                                                    if (formik.values.lst_Region?.id !== 0) {
                                                        triggerRegionSite({ siteId: selectedOption.value, regionId: formik.values.lst_Region?.id })
                                                    }
                                                }}
                                                isDisabled={regionSiteData?.result?.site !== null && regionSiteData?.result?.region !== null}

                                            />
                                            {formik.touched.lst_Site && formik.errors.lst_Site && (
                                                <>
                                                    <div className="error">{formik.errors.lst_Site.id}</div>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-wrap">
                                            <label className="input-label">
                                                Region <span className="text-danger">*</span>
                                            </label>
                                            <Select
                                                styles={customStyles}
                                                className="select"
                                                options={getdefaultLookups?.result?.Lst_Region?.map((option: any) => ({
                                                    label: option?.value,
                                                    value: option?.id
                                                }))}
                                                value={
                                                    formik.values?.lst_Region?.id
                                                        ? {
                                                            value: formik.values?.lst_Region?.id,
                                                            label: formik.values?.lst_Region?.value || '',
                                                        }
                                                        : []
                                                }
                                                onChange={(selectedOption: any) => {
                                                    formik.setFieldValue('lst_Region.id', selectedOption.value);
                                                    formik.setFieldValue('lst_Region.value', selectedOption.label);
                                                    if (formik.values.lst_Site?.id !== 0) {
                                                        triggerRegionSite({ siteId: formik.values?.lst_Site?.id, regionId: selectedOption.value })
                                                    }
                                                }}
                                                isDisabled={regionSiteData?.result?.site !== null && regionSiteData?.result?.region !== null}
                                            />
                                            {formik.touched.lst_Region && formik.errors.lst_Region && (
                                                <>
                                                    <div className="error">{formik.errors.lst_Region.id}</div>
                                                </>
                                            )}

                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <label className="input-label">
                                            Team<span className="text-danger"> *</span>
                                        </label>
                                        <Select
                                            styles={customStyles}
                                            menuPortalTarget={document.body}
                                            options={teamsData?.result?.map((option: any) => ({
                                                label: option?.value,
                                                value: option?.id
                                            })) || []}
                                            value={
                                                formik.values?.lst_UserTeam?.id
                                                    ? {
                                                        value: formik.values?.lst_UserTeam?.id,
                                                        label: formik.values?.lst_UserTeam?.value || '',
                                                    }
                                                    : []
                                            }
                                            className="select"
                                            onChange={(selectedOption: any) => {
                                                triggerTeamDetails({ teamID: selectedOption.value })
                                                triggerTeamsByName({ teamID: selectedOption.value })
                                                triggerTeamsByRole({ teamID: selectedOption.value })
                                                formik.setFieldValue("lst_UserTeam.id", selectedOption.value);
                                                formik.setFieldValue("lst_UserTeam.value", selectedOption.label);
                                            }}

                                        // isDisabled={isReadOnly}
                                        />
                                        {formik.touched.lst_UserTeam && formik.errors.lst_UserTeam && (
                                            <>
                                                <div className="error">{formik.errors.lst_UserTeam.id}</div>
                                            </>
                                        )}
                                    </div>
                                    <div className="col-md-6">
                                        <label className="input-label">
                                            Project ID<span className="text-danger"> *</span>
                                        </label>
                                        <input type="text" className="form-control" placeholder=""
                                            value={(regionSiteData?.result?.site !== null && regionSiteData?.result?.region !== null) ? formik.values.projectRecNumber : projectNumDynamic}
                                            disabled
                                        />
                                    </div>
                                    <div className='col-md-12 mt-4'>
                                        <div className='d-flex gap-3 mb-2 '>
                                            <div>
                                                <input
                                                    type="radio"
                                                    className="status-radio"
                                                    id="active"
                                                    name="format"
                                                    value="Name(Role)"
                                                    checked={selectedFormat === 'Name(Role)'}
                                                    onChange={handleRadioChange}
                                                />
                                                <label htmlFor="active">User Name(Role)</label>
                                            </div>
                                            <div>
                                                <input
                                                    type="radio"
                                                    className="status-radio"
                                                    id="active1"
                                                    name="format"
                                                    value="Role(Name)"
                                                    checked={selectedFormat === 'Role(Name)'}
                                                    onChange={handleRadioChange}
                                                />
                                                <label htmlFor="active1">User Role(Name)</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-md-12'>
                                        {/* <label className="input-label">
                                            Team Members: Classic <span className="text-danger">*</span>
                                        </label> */}
                                        <Select className='select'
                                            styles={customStyles}
                                            options={formik.values.lst_UserTeam.id !== 0 ? optionsTeam : []}
                                            isMulti={true}
                                            value={
                                                selectValuesTeam
                                            }
                                            onChange={(selectedList: any) => {
                                                handleChangeTeam(selectedList);
                                            }}
                                        />
                                    </div>
                                    <h4 className='mb-2 mt-4'> Assign Enterprise Members</h4>
                                    <div className='col-md-12 '>
                                        <label className="input-label">
                                            Business Unit
                                        </label>
                                        {/* <Select className='select' isMulti={true}  options={selectValues} />  */}
                                        <Select className='select'
                                            styles={customStyles}
                                            options={projectLookups?.result?.Lst_BusinessUnit?.map((option: any) => ({
                                                label: option?.value,
                                                value: option?.id
                                            })) || null}
                                            value={
                                                formik.values?.lst_EnterPriseBusinessUnit?.id
                                                    ? {
                                                        value: formik.values?.lst_EnterPriseBusinessUnit?.id,
                                                        label: formik.values?.lst_EnterPriseBusinessUnit?.value || '',
                                                    }
                                                    : null
                                            }
                                            onChange={(selectedOption: any) => {
                                                triggerTeamsByBusinessName({ businessUnitId: selectedOption.value })
                                                triggerTeamsByBusinessRole({ businessUnitId: selectedOption.value })
                                                formik.setFieldValue("lst_EnterPriseBusinessUnit.id", selectedOption.value);
                                                formik.setFieldValue("lst_EnterPriseBusinessUnit.value", selectedOption.label);
                                            }}
                                        />
                                        {/* {formik.touched.lst_EnterPriseBusinessUnit && formik.errors.lst_EnterPriseBusinessUnit && (
                                            <>
                                                <div className="error">{formik.errors.lst_EnterPriseBusinessUnit.id}</div>
                                            </>
                                        )} */}
                                    </div>
                                    <div className='col-md-12 mt-3'>
                                        <div className='d-flex gap-3 mb-2 '>
                                            <div>
                                                <input
                                                    type="radio"
                                                    className="status-radio"
                                                    id="activeBusniess"
                                                    name="formatBusiness"
                                                    value="Name(Role)"
                                                    checked={selectedFormatBusiness === 'Name(Role)'}
                                                    onChange={handleRadioChangeBusiness}
                                                />
                                                <label htmlFor="activeBusniess">User Name(Role)</label>
                                            </div>
                                            <div>
                                                <input
                                                    type="radio"
                                                    className="status-radio"
                                                    id="activeBusiness1"
                                                    name="formatBusiness"
                                                    value="Role(Name)"
                                                    checked={selectedFormatBusiness === 'Role(Name)'}
                                                    onChange={handleRadioChangeBusiness}
                                                />
                                                <label htmlFor="activeBusiness1">User Role(Name)</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-md-12'>
                                        {/* <Select className='select' isMulti={true}  options={selectValues} />  */}
                                        <Select className='select'
                                            styles={customStyles}
                                            options={formik.values?.lst_EnterPriseBusinessUnit.id !== 0 ? optionsBusinesTeam : []}
                                            isMulti={true}
                                            value={
                                                selectValuesTeamBusiness
                                            }
                                            onChange={(selectedList: any) => {
                                                handleChangeTeamBusiness(selectedList);
                                            }}
                                        />

                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default AssignmentSidebar